import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FobCantonEditingDialog from '../DialogEditingType/FobCantonEditingDialog';
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_MASTER, ROLE_SENIOR_MASTER } from '../../../Constants/ConstantsOptics';
import { FOB, FOB_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../../Modal/ModalDescriptionComponentSpecifically';
import DialogFobFoto from '../DialogFoto/DialogFobFoto';
import { fetchFobFileCount } from '../CountFile/FileCount';
import { fetchFobConnectionCount } from '../CountFile/ConnectionCount';

const FobCantonDialog = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, role, user,
  groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData, ponBoxLocationData, pillarData, cantonFobRefresh,
  setIsComponentСhangeCoorFob, territoryList}) => {


  const [openModalEditing, setOpenModalEditing] = useState(false);
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [openModalFoto, setOpenModalFoto] = useState(false);
  const [fileCount, setFileCount] = useState(0);
  const [connectionCount, setConnectionCount] = useState(0);

  const openModalDescriptionComponents = () => {
    if(connectionCount != 0){
       setOpenModalDescription(true);
    }
  }; 

  const openModalFotoFile = () => {
    if(fileCount != 0){
      setOpenModalFoto(true);
    }
  }; 

  const openModalEditingContent = () => {
    setOpenModalEditing(true);
  };  

  useEffect(() => {
    const updateFileCount = async () => {  
      const count = await fetchFobFileCount(content.id);
      if (count !== null) {
        setFileCount(count); 
      }
    };
    updateFileCount();
  });

  useEffect(() => {
    const updateConnectionCount = async () => {  
      const count = await fetchFobConnectionCount(content.id);
      if (count !== null) {
        setConnectionCount(count); 
      }
    };
    updateConnectionCount();
  });

  return (
    <Dialog open={open} className="dialogStyle">
    <DialogContent>
    {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./fob_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
    )}
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #0a0a0aff'}}>Фоб</label>
    <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #131313ff' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "фоб"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Город: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #141414ff'}}>{content.city}</span> </label>
      <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !content.canton ? '#de858e' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {content.canton
                    ? content.region && content.area
                      ? `${content.canton} ${content.region} ${content.area}`
                      : content.canton
                    : 'нет'}
                </span>
              </label>  
           <hr className='horizontalLineDialog'/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ODF: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #111111ff' }}>{content.fobName}</span> </label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #0e0e0eff'}}>{content.rankComponentName}</span> </label>
      <br/>
        <label style={{ color: '#292929', fontWeight: 'bold' }}>
           Признак: 
           <span style={{ color: content.ether === 1 || content.pon === 1 || content.ktv === 1 ? '#bdab6f' : '#de858e' ,textShadow: '2px 2px 4px #111111ff'}}>
             {[
                content.pon === 1 && ' PON',
                content.ktv === 1 && ' KTV',
                content.ether === 1 && ' Ethernet'
             ]
              .filter(Boolean)
             .join(', ') || ' Нет'}
           </span>
        </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #161616ff' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #141414ff'}}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #131313ff' }}>{content.description}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalDescriptionComponents} class='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #181818ff'}}>
        Связи
          <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
            {connectionCount > 0 ? connectionCount : 'нет'}
          </span>
        </button>

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalFotoFile} className='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #222222ff'}}>
        Просмотр файлов
        <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
           {fileCount > 0 ? fileCount : 'нет'}
        </span>
      </button>     
      
       <hr className='horizontalLineDialog'/>
    </DialogContent>

    <DialogActions>
    {/* {((user === content.authorId && (role.role === ROLE_ENGINNER || role.role === ROLE_SENIOR_MASTER )) || role.role === ROLE_ADMIN) && ( */}
     {(
        (
          (user === content.authorId &&
          (role.role === ROLE_ENGINNER || role.role === ROLE_MASTER)
          ) ||
          role.role === ROLE_ADMIN ||
          (role.role === ROLE_ENGINNER  && territoryList.includes(content.canton))
        )       
      ) && (
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
      </Button>
    )}
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

   {/* Snackbar */}
   <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

       {/* Modal Foto*/}
       <DialogFobFoto
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}     
      />    

        <ModalDescriptionComponentSpecifically
          open={openModalDescription}
          onClose={() => setOpenModalDescription(false)}
          id={content.id}
          type={FOB}
          flag={FOB_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />
      
      {/* Modal редактирование FobCanton*/}
      <FobCantonEditingDialog
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        user={user}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        cantonFobRefresh={cantonFobRefresh}
        setIsComponentСhangeCoorFob={setIsComponentСhangeCoorFob}
      />        
    </Dialog> 
  );
}

export default FobCantonDialog;